// extracted by mini-css-extract-plugin
export default {"card":"Card_card__QrQyW","card__icon":"Card_card__icon__1k02w","card__title":"Card_card__title__INqgL","card__descr":"Card_card__descr__A+t0B"};